import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';

/**
 * The svg wrapper component.
 * 
 * @since 1.0.0
 */
function Svg( props )
{
	// props
	const { className: classes, color, target, viewBox, ...rest } = props;

	// Refs
	const mounted = useRef();

	/**
	 * Handle component lifecycle
	 * 
	 * componentDidMount? componentWillUnmount?
	 */
	useEffect(() => {

		// componentDidMount

	}, []);

	/**
	 * Handle component lifecycle
	 * 
	 * componentDidUpdate?
	 */
	useEffect(() => {

		if ( ! mounted.current ) {
			mounted.current = true;
		} else {
			// componentDidUpdate
		}

	});

	/**
	 * Render component
	 * 
	 * @return object
	 */
	return (
		<div
			className={classnames({
				[classes]: classes
			})}
		>
			<svg
				version="1.1"
				viewBox={viewBox}
				xmlSpace="preserve"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				className="e-svg"
				{ ...rest }
			>
				<use xlinkHref={target} fill={color} />
			</svg>
		</div>
	);
}

/**
 * Set default props
 */
Svg.defaultProps = {
	color: '',
	target: '',
	viewBox: ''
};

/**
 * Module exports
 * @public
 */
export default Svg;